import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import SendPharmacyIcon from "../../images/icons/SendPharmacyIcon.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import * as yup from "yup";
import TrashIcon from "../../images/icons/TrashIcon.svg";
import AlertInfoIcon from "../../images/icons/AlertInfoIcon.svg";
import {
  AlertInfo,
  BtnGroupStyle,
  ContentStyle,
  DataGridListStyle,
  DRxInputStyle,
  InputSMBoxStyle,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import ConfirmPopup from "../../components/ConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import { loadingEpcsQueue } from "../../Redux/Slice/EPCSQueueSlice";
import { v4 as uuid } from "uuid";
import {
  EPCSSendToPharmacy,
  RemoveEpcsQueueById,
  updatePatientEmail,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import NoRecords from "../../components/NoRecords";
import {
  DrugTextNTooltip,
  PharmacyTextNTooltip,
  TextOnly,
} from "../../components/Content";
import ErrorOverlay from "../../components/ErrorOverlay";
import { loadingTopRibbon } from "../../Redux/Slice/TopRibbonSlice";
import EPCSAlert from "../../components/EPCSAlert";
import { useSearchParams } from "react-router-dom";
import { Formik } from "formik";
import { loadingPrescriberDetails } from "../../Redux/Slice/PrescriberDetailsSlice";
import {
  IDME_URL_DOMAIN,
  IDME_URL_END,
  REPORT_BASE_URL,
} from "../../Apis/Constants";
import IDME from "../../components/IDME";
import { saveAsPreferenceApi } from "../../Apis/Idme2FA";
import { clearIdmePreferenceState } from "../../Redux/Slice/IdmeSlice";

export default function EpcsQueue() {
  const EpcsAlert2FA = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/sendToIdMe?domain=drx.domain.ux.upgrade.${IDME_URL_END}.epcsqueue`;
  const dispatch = useDispatch();
  const PrescriberDetailsState = useSelector((state: any) => {
    return { ...state?.PrescriberDetailsSlice };
  }); //redux data
  const EpcsQueueData = useSelector((state: any) => {
    return { ...state?.EPCSQueueSlice };
  }); //To get data from redux store state
  const [selectionData, setSelectionData] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [searchParams] = useSearchParams();
  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const [emailUpdatePopup, emailUpdateSetPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [epcsSendToPharmacyData, setSendToPharmacyData] = useState<any>([]);
  const [sendToPharmacyError, setSendToPharmacyError] = useState("");
  const [page, setPage] = useState(0);
  const [deletePharmacyPopup, setDeletePharmacyPopup] = useState(false);
  const [sendPharmacyPopup, setSendPharmacyPopup] = useState(false);
  const [iDmePopup, setIDMEPopup] = useState(false);
  const [verifiedIdmeUuid, setVerifiedByIdmeUuid] = useState<string | null>(
    null
  );
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [rowCountState, setRowCountState] = useState(
    EpcsQueueData?.Pagination?.totalItems || 0
  );
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    setApprovedPopup(false);
  };
  const handleShowEmailUpdatePopupClick = () => {
    emailUpdateSetPopup(true);
  };
  const handleHideEmailUpdatePopupClick = () => {
    emailUpdateSetPopup(false);
  };
  const handleShowIDMEPopupClick = () => {
    setIDMEPopup(true);
  };
  const handleHideIDMEPopupClick = () => {
    setIDMEPopup(false);
    setTimeout(() => {
      dispatch(clearIdmePreferenceState());
    }, 1000);
  };
  const handleShowSentPopupClick = () => {
    setSendPharmacyPopup(true);
  };
  const handleHideSentPopupClick = () => {
    setSendPharmacyPopup(false);
  };
  const handleShowDeletePopupClick = () => {
    setDeletePharmacyPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePharmacyPopup(false);
  };

  const updateEmailReminder = async (values: any) => {
    try {
      const params: any = new URLSearchParams();
      params.append("doctorId", localStorage.getItem("doctorId"));
      params.append("email", values.email);
      const result = await updatePatientEmail(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          handleHideEmailUpdatePopupClick();
          dispatch(loadingPrescriberDetails());
        }, 1000);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Sometime!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const getEPCSSendToPharmacy = async (authCheck?: any) => {
    setLoading(true);
    handleShowApprovedPopupClick();
    try {
      const bodyData = {
        authorization: authCheck,
        authenticationEventUUID: verifiedIdmeUuid,
        authenticationUserUUID: localStorage.getItem("userIdmeUuid"),
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: localStorage.getItem("doctorId"),
          onBehalfDoctorId: "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result: any = await EPCSSendToPharmacy(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setSendToPharmacyData(result?.data?.response[0]);
        dispatch(loadingTopRibbon());
        getEPCSQueueData(page);
        setLoading(false);
        setSendToPharmacyError("");
        localStorage.removeItem("userIdmeUuid");
        localStorage.removeItem("savedPreferenceForRoute");
      } else {
        setSendToPharmacyData([]);
        setLoading(false);
        setSendToPharmacyError(result?.data?.digitalRxStatusMessage);
      }
    } catch (error) {
      setSendToPharmacyData([]);
      setLoading(false);
      setSendToPharmacyError("Something went wrong, please try again later!");
    }
  };

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("epcsPrescriptionId", selectionData);
      const result = await RemoveEpcsQueueById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        dispatch(loadingTopRibbon());
        getEPCSQueueData(page);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const columnsEpcsQueue: GridColDef[] = [
    {
      field: "name",
      headerName: "Patient Name",
      width: 190,
      cellClassName: "w18",
      headerClassName: "w18",
      renderCell: ({ row }) => (
        <Typography className="textwrap">
          <Typography variant="body2" component={"div"}>
            {row.patientFirstName} {row.patientLastName}
          </Typography>
        </Typography>
      ),
    },
    {
      field: "description",
      headerName: "Drug Description",
      width: 190,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: ({ row }) => <DrugTextNTooltip row={row} />,
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 190,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: ({ row }) => <PharmacyTextNTooltip row={row} />,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 110,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "rxType",
      headerName: "Rx Type",
      width: 120,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 70,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: ({ row }) => {
        return (
          <Tooltip title="Delete">
            <IconButton
              type="button"
              onClick={() => {
                handleShowDeletePopupClick();
                setSelectionData(row.id);
              }}
            >
              <img src={TrashIcon} alt="Delete" loading="lazy" />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const getEPCSQueueData = (nextPage: number) => {
    let paramsData = {
      pageNumber: nextPage,
      pageSize: pageSize,
    };
    dispatch(loadingEpcsQueue(paramsData));
  };

  const submitPreferenceRoute = async () => {
    try {
      const body = {
        settingType: "MFA_ROUTE",
        enabled: true,
        savedPreference: localStorage.getItem("savedPreferenceForRoute"),
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        console.log("🚀 ~ submitPreference ~ result?.data:", result?.data);
      }
    } catch (error) {
      console.log("🚀 ~ submitPreference ~ error:", error);
    }
  };
  useEffect(() => {
    const authCheck: string | null = searchParams.get("authorization");
    if (authCheck === "true" || verifiedIdmeUuid) {
      if (localStorage.getItem("savedPreferenceForRoute") === "0") {
        Promise.all([
          submitPreferenceRoute(),
          getEPCSSendToPharmacy(authCheck),
        ]);
      } else {
        getEPCSSendToPharmacy(authCheck);
      }
    }
  }, [verifiedIdmeUuid]);

  useEffect(() => {
    getEPCSQueueData(page);
  }, [page]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      EpcsQueueData?.Pagination?.totalItems !== undefined
        ? EpcsQueueData?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [EpcsQueueData?.Pagination?.totalItems, setRowCountState]);

  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          EPCS Queue
          <HelpGuideTooltip
            content={
              <>
                {" "}
                <Typography component="div" variant="body1">
                  You can queue up all of your EPCS prescriptions here and send
                  them all at once.
                </Typography>
              </>
            }
            pdf={`${REPORT_BASE_URL}drx/PDF/EPCS_Queue_User_Manual_V1.pdf`}
            video={"https://vimeo.com/699390756/e244aaf9bf"}
          />
        </Typography>

        <Stack sx={{ width: "100%" }} spacing={2} marginBottom={1}>
          <AlertInfo>
            {PrescriberDetailsState?.AllPrescriberDetails?.email === null ||
            PrescriberDetailsState?.AllPrescriberDetails?.email === "" ? (
              <Typography component={"div"} variant={"body2"}>
                EPCS Queue related notifications will be sent to your mail,
                Please add your mail here{" "}
                <Typography
                  color="primary"
                  display="inline"
                  onClick={handleShowEmailUpdatePopupClick}
                >
                  {">>"}Update
                </Typography>
              </Typography>
            ) : (
              <Typography component={"div"} variant={"body2"}>
                <img src={AlertInfoIcon} alt="Alert" loading="lazy" /> EPCS
                Queue related notifications will be sent to{" "}
                <b>
                  {PrescriberDetailsState?.AllPrescriberDetails?.email ??
                    "Email Not Available"}
                </b>{" "}
                Please contact support to update your email address.
              </Typography>
            )}
          </AlertInfo>
        </Stack>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={EpcsQueueData?.Items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columnsEpcsQueue}
                paginationMode="server"
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                rowsPerPageOptions={[pageSize]}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                disableSelectionOnClick
                page={page}
                loading={EpcsQueueData?.isLoading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={EpcsQueueData?.error || undefined}
                getRowId={(row) => row?.id ?? uuid()}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12} my={2}>
            <BtnGroupStyle className="middle">
              <YSButton
                onClick={handleShowSentPopupClick}
                className=""
                children={"Send to Pharmacy"}
                disabled={EpcsQueueData?.Items?.length > 0 ? false : true}
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
                startIcon={
                  <img
                    src={SendPharmacyIcon}
                    alt="Send to Pharmacy"
                    loading="lazy"
                  />
                }
              />
            </BtnGroupStyle>
          </Grid>
        </Grid>
      </ContentStyle>
      {/* EPCS Alert */}
      <DialogPopup
        title="EPCS Alert"
        windowsize={"sm"}
        show={sendPharmacyPopup}
        handleShowPopupClick={handleShowSentPopupClick}
        handleHidePopupClick={handleHideSentPopupClick}
      >
        <EPCSAlert
          multiDea={true}
          URL={EpcsAlert2FA}
          handleHideSentPopupClick={handleHideSentPopupClick}
          handleShowIDMEPopupClick={handleShowIDMEPopupClick}
        />
      </DialogPopup>
      {/* IDME verification popup */}
      <DialogPopup
        title="Two-Factor Authentication"
        windowsize={"md"}
        show={iDmePopup}
        handleShowPopupClick={handleShowIDMEPopupClick}
        handleHidePopupClick={handleHideIDMEPopupClick}
      >
        <IDME
          URL={EpcsAlert2FA}
          setVerifiedByIdmeUuid={setVerifiedByIdmeUuid}
          handleHidePopupClick={handleHideIDMEPopupClick}
        />
      </DialogPopup>
      {/* delete popup */}
      <DialogPopup
        windowsize={"sm"}
        show={deletePharmacyPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      {/* Prescriber status */}
      <DialogPopup
        title="Prescribed Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        {loading ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : sendToPharmacyError ? (
          <>
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              height={"50vh"}
            >
              <Typography color="error" variant="subtitle2" fontWeight={600}>
                {sendToPharmacyError}
              </Typography>
            </Grid>
          </>
        ) : (
          <Grid
            container
            item
            xs={12}
            spacing={1}
            alignItems="top"
            justifyContent="center"
          >
            {epcsSendToPharmacyData?.statusCode === 0 ? (
              <Grid item xs={12} textAlign={"center"}>
                <CheckCircleOutlineIcon
                  style={{ height: 70, width: 70 }}
                  color="success"
                />
              </Grid>
            ) : epcsSendToPharmacyData?.statusCode === 2 ? (
              <Grid item xs={12} textAlign={"center"}>
                <CancelOutlinedIcon
                  style={{ height: 70, width: 70 }}
                  color="error"
                />
              </Grid>
            ) : epcsSendToPharmacyData?.statusCode === 1 ? (
              <Grid item xs={12} textAlign={"center"}>
                <ErrorOutlineOutlinedIcon
                  style={{ height: 70, width: 70 }}
                  color="warning"
                />
              </Grid>
            ) : null}
            {epcsSendToPharmacyData?.epcsQueueReturnList?.length >= 1 && (
              <>
                <Grid item xs={12} textAlign={"left"}>
                  {epcsSendToPharmacyData?.epcsQueueReturnList?.map(
                    (each: any) => (
                      <>
                        <Typography
                          component="div"
                          variant="subtitle2"
                          fontWeight={600}
                        >
                          {each?.status
                            ? "Successful transactions :"
                            : "Failure transactions :"}
                        </Typography>
                        <ul>
                          <li>
                            <Typography
                              color={"primary"}
                              component={"div"}
                              variant={"body2"}
                              fontWeight={700}
                            >
                              {each?.patientName}
                            </Typography>
                            <Typography
                              color={"primary"}
                              component={"div"}
                              variant={"body2"}
                              fontWeight={600}
                            >
                              {each?.drugDescription}
                            </Typography>
                            {each?.status ? (
                              <Typography component={"div"} variant={"body2"}>
                                {each?.statusDescription}
                              </Typography>
                            ) : (
                              <Typography component={"div"} variant={"body2"}>
                                {each?.errorDescription}
                              </Typography>
                            )}
                          </li>
                        </ul>
                      </>
                    )
                  )}
                </Grid>
              </>
            )}
          </Grid>
        )}
      </DialogPopup>

      {/* Update Email */}
      <DialogPopup
        title={"Update Contact Info"}
        windowsize={"sm"}
        show={emailUpdatePopup}
        handleShowPopupClick={handleShowEmailUpdatePopupClick}
        handleHidePopupClick={handleHideEmailUpdatePopupClick}
      >
        <Formik
          validationSchema={yup.object().shape({
            email: yup.string().email("Invalid email."),
          })}
          initialValues={{ email: "" }}
          onSubmit={(values: any) => {
            updateEmailReminder(values);
          }}
        >
          {(emailProps: any) => (
            <Grid
              container
              item
              xs={12}
              spacing={1}
              alignItems="top"
              justifyContent="center"
            >
              <Grid item xs={12}>
                <Typography component="span" variant="body2" fontWeight={400}>
                  EPCS Queue related notifications will be sent to your mail
                  address. Please let us know your mail to keep you updated.
                </Typography>{" "}
              </Grid>
              <Grid item xs={12}>
                <InputSMBoxStyle>
                  <Typography
                    component="label"
                    variant="body2"
                    htmlFor="lastname"
                  >
                    Email
                  </Typography>{" "}
                  <Box>
                    <DRxInputStyle>
                      <TextField
                        id="email"
                        name="email"
                        type="text"
                        className="input"
                        disabled={false}
                        value={emailProps.values?.email}
                        onChange={emailProps.handleChange}
                      />
                    </DRxInputStyle>
                    <YSButton
                      className={""}
                      children={"Save"}
                      onClick={() => {
                        emailProps.handleSubmit();
                      }}
                      variant={"contained"}
                      size={"large"}
                      style={{ marginTop: 10 }}
                    />
                  </Box>
                </InputSMBoxStyle>
              </Grid>
            </Grid>
          )}
        </Formik>
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
